import React from "react";
import classes from "../index.module.css";

const BtnSubmit = (props) => {
  const {
    text,
    bgColor,
    color,
    border,
    display,
    width,
    padding,
    onClick,
    showIcon,
    disable = false,
    icon,
    icon_alt,
  } = props;

  const fontWeight = text === "Filter" || text === "Export" ? "600" : "normal";
  // const fontMarginBottom = text === "filter" ? "-4px" : "-7px";

  return (
    <div className={classes.BtnClick}>
      <button
        style={{
          backgroundColor: (!disable && bgColor) || "#D9D9D9",
          color: color,
          border: border,
          display: display,
          height: "100%",
          width: width,
          padding: padding,
          margin: "0 10px 0 0",
          fontWeight: fontWeight,
          cursor: !disable && "pointer",
        }}
        onClick={onClick}
        type="submit"
        disabled={disable}
      >
        {showIcon && (
          <img
            src={icon}
            alt={icon_alt}
            style={{ marginRight: "7px", marginBottom: "-7px" }}
          ></img>
        )}
        {text}
      </button>
    </div>
  );
};

export default BtnSubmit;
